import { all } from 'redux-saga/effects';
import loginWatcher from './login/loginSaga';
import mttDashboardWatcher from './mttDashboard/mttDashboardSaga';

export default function* rootSaga(): any {
  yield all([loginWatcher(), mttDashboardWatcher()]);
}
